// common
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule, Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

// ngrx
import { StoreModule } from '@ngrx/store';

// combined common modules into one file

// components & containers

// guards
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxPaginationModule } from 'ngx-pagination';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';

// date and time pickers
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

// apex charts
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ToggleComponent } from '../../shared/components/toggle/toggle.component';
import { SharedModule } from '../../shared/shared.module';
import * as fromUsersReducer from '../../store/reducers/users.reducer';
import * as fromComponents from './components';
import * as fromContainers from './pages';

const umnPageRoutes: Routes = [
  {
    path: '',
    component: fromContainers.UnmPageComponent,
    canActivate: [NgxPermissionsGuard],
  },
];

@NgModule({
  imports: [
    SharedModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatFormFieldModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    ScrollingModule,
    RouterModule.forChild(umnPageRoutes),
    StoreModule.forFeature('user', fromUsersReducer.reducer),
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    NgApexchartsModule,
    MatGridListModule,
    MatToolbarModule,
    NgxMatTimepickerModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatInputModule,
    MatCheckboxModule,
    ToggleComponent,
  ],
  declarations: [...fromComponents.components, ...fromContainers.containers],
  exports: [...fromComponents.components, ...fromContainers.containers],
})
export class UnusualNetworkMetricsModule {}
